import { render, staticRenderFns } from "./SelectPeriodo.vue?vue&type=template&id=9aa4cf3e&scoped=true&"
import script from "./SelectPeriodo.vue?vue&type=script&lang=js&"
export * from "./SelectPeriodo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9aa4cf3e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
